window.arCurriculumVitaeFormatter = function(value, row) {
    let html = '';
    html += '<a href="/ar/curriculum-vitaes/show/'+row.curriculum_vitae_id+'">';
    html += '<i class="fa fa-id-card"></i>';
    html += '</a>';
    return html;
}
